import { Dispatch, SetStateAction } from 'react';
import { GetPatientsBalanceResponse_PatientBalance } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { useMultiStepModal } from '@frontend/payments-multistep-modal';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { Modal } from '@frontend/design-system';
import { useBulkCollectionSelectAllShallowStore } from '../../../../store/bulk-collections-select-all-store';
import { BULK_CREATE_STEPS } from '../bulk-create-steps-key-title';
import { Filters } from '../filters/filters';
import { useFilters } from '../filters/use-filters';
import { useValidateUsersShallowStore } from '../stores/validate-users-store';
import { styles } from './styles';
import { DesktopList } from './validate-users-step/desktop-list';
import { Footer } from './validate-users-step/footer';
import { MobileList } from './validate-users-step/mobile-list';

type ValidateUsersStepProps = {
  patients: GetPatientsBalanceResponse_PatientBalance[];
  onSelectionChange: Dispatch<SetStateAction<Record<string, boolean>>>;
  selected: Record<string, boolean>;
  useNewApi: boolean;
};
export const ValidateUsersStep = ({ patients, onSelectionChange, selected, useNewApi }: ValidateUsersStepProps) => {
  const { goToStep, closeModal } = useMultiStepModal();
  const isMobile = useMatchMedia({ maxWidth: breakpoints.xsmall.max });
  const { data: filteredPatients, handleFilterChange } = useFilters(patients);
  const { selectedCount, handleBulkExclusion } = useBulkCollectionSelectAllShallowStore(
    'selectedCount',
    'handleBulkExclusion'
  );
  const { excluded } = useValidateUsersShallowStore('excluded');

  return (
    <>
      <Modal.Body css={styles.modalBody(true)}>
        <Filters onChange={handleFilterChange} hideLocation={isMobile} useNewApi={useNewApi} />
        {isMobile ? (
          <MobileList
            patients={filteredPatients}
            selected={selected}
            onSelectionChange={onSelectionChange}
            useNewApi={useNewApi}
          />
        ) : (
          <DesktopList
            patients={filteredPatients}
            onSelectionChange={onSelectionChange}
            selected={selected}
            useNewApi={useNewApi}
          />
        )}
      </Modal.Body>
      <Footer
        closeModal={() => {
          handleBulkExclusion(excluded);
          closeModal();
        }}
        selectedCount={useNewApi ? selectedCount - excluded.length : Object.values(selected).filter(Boolean).length}
        onTextToPayClick={() => {
          handleBulkExclusion(excluded);
          goToStep(BULK_CREATE_STEPS.SEND_SMS.id);
        }}
      />
    </>
  );
};
